<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      
      <a-form-model-item prop="tagName" >
        <span slot="label" ><a-tooltip>{{$t('标签名称')}}<template slot="title">{{$t('标签名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.tagName" :maxLength="64" :placeholder="$t('请输入')+'标签名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="tagCode" >
        <span slot="label" ><a-tooltip>{{$t('标签编码')}}<template slot="title">{{$t('标签编码')}}</template></a-tooltip> </span>
        <a-input v-model="form.tagCode" :maxLength="64" :placeholder="$t('请输入')+'标签编码'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="iconUrl" >
        <span slot="label" ><a-tooltip>{{$t('标签图标')}}<template slot="title">{{$t('标签图标')}}</template></a-tooltip> </span>
        <a-input v-model="form.iconUrl" :maxLength="255" :placeholder="$t('请输入')+'标签图标'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="description" >
        <span slot="label" ><a-tooltip>{{$t('标签描述')}}<template slot="title">{{$t('标签描述')}}</template></a-tooltip> </span>
        <a-input v-model="form.description" :maxLength="255" :placeholder="$t('请输入')+'标签描述'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="sortOrder" >
        <span slot="label" ><a-tooltip>{{$t('排序')}}<template slot="title">{{$t('排序')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.sortOrder" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'排序'" />
      </a-form-model-item>
      
      <a-form-model-item prop="status" >
        <span slot="label" ><a-tooltip>{{$t('状态')}}<template slot="title">{{$t('状态')}}</template></a-tooltip> </span>
        <a-radio-group v-model="form.status" style="width: 100%">
          <a-radio value="1">{{$t('启用')}}</a-radio>
          <a-radio value="0">{{$t('禁用')}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCampsiteInterestTag, addCampsiteInterestTag, updateCampsiteInterestTag } from '@/api/campsite/campsiteInterestTag'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        parentId: null,
        tagName: null,
        tagCode: null,
        iconUrl: null,
        description: null,
        sortOrder: null,
        level: null,
        status: 0,
        createdAt: null,
        updatedAt: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          tagName: [{ required: true, message: this.$t('标签名称')+this.$t('不能为空'), trigger: 'blur' }] ,
          tagCode: [{ required: true, message: this.$t('标签编码')+this.$t('不能为空'), trigger: 'blur' }] ,
          sortOrder: [{ required: true, message: this.$t('排序值，越小越靠前')+this.$t('不能为空'), trigger: 'blur' }] ,
          status: [{ required: true, message: this.$t('状态：1启用 0禁用')+this.$t('不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        parentId: null,
        tagName: null,
        tagCode: null,
        iconUrl: null,
        description: null,
        sortOrder: null,
        level: null,
        status: 0,
        createdAt: null,
        updatedAt: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCampsiteInterestTag({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCampsiteInterestTag(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCampsiteInterestTag(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
